"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.icons = void 0;
// @TODO: change light icons
exports.icons = [
    {
        iconSolid: ["fas", "calendar-minus"],
        iconLight: ["fal", "calendar-minus"]
    },
    {
        iconSolid: ["fas", "utensils"],
        iconLight: ["fal", "utensils"]
    },
    {
        iconSolid: ["fas", "dumbbell"],
        iconLight: ["fal", "dumbbell"]
    },
    {
        iconSolid: ["fas", "book"],
        iconLight: ["fal", "book"]
    },
    {
        iconSolid: ["fas", "weight"],
        iconLight: ["fal", "weight"]
    },
    {
        iconSolid: ["fas", "bed"],
        iconLight: ["fal", "bed"]
    },
    {
        iconSolid: ["fas", "address-book"],
        iconLight: ["fal", "address-book"]
    },
    {
        iconSolid: ["fas", "comment"],
        iconLight: ["fal", "comment"]
    },
    {
        iconSolid: ["fas", "child"],
        iconLight: ["fal", "child"]
    }
];
//# sourceMappingURL=navIcons.js.map